<p-tree [value]="companyTreeNodes" selectionMode="single" (onNodeSelect)="selectionChanged($event)"></p-tree>
